import styled from 'styled-components';

type Props = {
  showButton: boolean;
};

export const PreviousCampaignStyled = styled.div<Props>`
  .previousCampaign {
    &__container {
      background-color: ${props => props.theme.uiColors.contextSystemViewItemBackground};
      border-radius: 6px;
      display: flex;
      justify-content: ${props => (props.showButton ? 'center' : 'start')};
      padding: 16px;
    }
  }
`;
